import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  customizeStep,
  previousStep,
} from "../../../redux/actions/standard/homeActions";
import {
  Tabs,
  Radio,
  CheckBox,
  UploadFile,
  IconButton,
  UpgradeCard,
  ErrorMessage,
} from "../../../components";
import { FaAngleRight, FaAngleLeft } from "react-icons/fa";
import {
  tabsData,
  fields,
  personalInformation,
  academicRecords,
  employmentHistoy,
  personalPaid,
  academicRecordsPaid,
  defaultImages,
} from "./data";
import { useSelector } from "react-redux";
import { Lightbox } from "react-modal-image";
import { toAbsoluteUrl } from "../../../services";
import { BiDesktop, BiMobile } from "react-icons/bi";

import { InformationCircleIcon, LockClosedIcon } from "@heroicons/react/solid";
import ReactTooltip from "react-tooltip";
import "./customizeStep.css";
import HelpButton from "../../../components/button/helpButton";

// import { postApi } from "../../services/helpers/apiCall";
// import authHeader from "../../services/auth/auth-header";
// import UploadFileHeader from "../../services/auth/uploadFileHeader";

// get step data from redux main state
const data = (state) => state.standardHome.step3Data;

let CustomizeStep = (props) => {
  // savedData
  let savedData = useSelector(data);
  var isEmpty = Object.entries(savedData).length > 0;

  // Main Tab Handler State

  const [activeTab, setActiveTab] = useState(0);
  const [upgrade, setUpgrade] = useState(false);

  // Nested Tab Handler State
  const [selectedTab, setSelectedTab] = useState(0);

  // Error Handler
  const [loginError, setLoginError] = useState(false);
  const [imageUploadError, setImageUploadError] = useState(false);
  const [artWorkError] = useState(false);
  const [message, setMessage] = useState("");

  // Perosnal Information Functions start

  let personalInformationSaved =
    isEmpty === true
      ? savedData.personalInformationData
        ? savedData.personalInformationData
        : personalInformation
      : personalInformation;

  const [personalInformationData, setPersonalInformaionData] = useState(
    personalInformationSaved
  );

  let checkAllPersonalInformation =
    isEmpty === true
      ? personalInformationData.length === savedData.personalInFeilds.length
        ? true
        : false
      : false;

  const [selectPersonalInAll, setSelectPersonalInAll] = useState(
    checkAllPersonalInformation
  );
  const [personalInFeilds, setPersonalInFeilds] = useState(
    isEmpty === true
      ? savedData.personalInFeilds
      : ["Full Name", "Email Address"]
  );
  const [disPersonalInFeilds] = useState(["Full Name", "Email Address"]);

  const handlePersonalInformationChange = (event) => {
    var updatedList = [...personalInFeilds];
    if (event.target.checked) {
      updatedList = [...personalInFeilds, event.target.value];
    } else {
      updatedList.splice(personalInFeilds.indexOf(event.target.value), 1);
    }

    setSelectPersonalInAll(
      updatedList.length === personalInformationData.length ? true : false
    );
    setPersonalInFeilds(updatedList);
  };

  let handleSelectAll = () => {
    setSelectPersonalInAll(!selectPersonalInAll);
    if (!selectPersonalInAll) {
      setPersonalInFeilds(personalInformationData);
    } else {
      setPersonalInFeilds(disPersonalInFeilds);
    }
  };

  // Perosnal Information Functions end

  // Academic state

  let academicInformationSaved =
    isEmpty === true
      ? savedData.academicInformationSaved
        ? savedData.academicInformationSaved
        : academicRecords
      : academicRecords;
  const [academicInformationData, setAcademicInformationData] = useState(
    academicInformationSaved
  );

  let checkAllAcademicInformation =
    isEmpty === true
      ? academicInformationData.length === savedData.academicFeilds.length
        ? true
        : false
      : false;

  const [selectAcademicAll, setSelectAcademicAll] = useState(
    checkAllAcademicInformation
  );
  const [academicFeilds, setAcademicFeilds] = useState(
    isEmpty === true ? savedData.academicFeilds : []
  );
  const [disAcademicFeilds] = useState([]);

  const handleAcademicChange = (event) => {
    var updatedList = [...academicFeilds];
    if (event.target.checked) {
      updatedList = [...academicFeilds, event.target.value];
    } else {
      updatedList.splice(academicFeilds.indexOf(event.target.value), 1);
    }

    setSelectAcademicAll(
      updatedList.length === academicInformationData.length ? true : false
    );
    setAcademicFeilds(updatedList);
  };

  let handleAcademicAll = () => {
    setSelectAcademicAll(!selectAcademicAll);
    if (!selectAcademicAll) {
      setAcademicFeilds(academicInformationData);
    } else {
      setAcademicFeilds(disAcademicFeilds);
    }
  };

  // Main Functions

  // login Method State
  const [loginMethod, setLoginMethod] = useState(
    isEmpty === true ? savedData.loginMethod : "emailLogin"
  );
  // Custom ArtWork State
  const [landingLoginD, setLandingLoginD] = useState(
    isEmpty === true ? savedData.landingLoginD : defaultImages[0]
  );

  const [endscreenD, setEndScreenD] = useState(
    isEmpty === true ? savedData.endscreenD : defaultImages[1]
  );
  const [landingLoginM, setLandingLoginM] = useState(
    isEmpty === true ? savedData.landingLoginM : defaultImages[2]
  );
  const [endscreenM, setEndScreenM] = useState(
    isEmpty === true ? savedData.endscreenM : defaultImages[3]
  );

  const [favicon, setFavicon] = useState(
    isEmpty === true ? savedData.favicon : defaultImages[4]
  );
  // Next and Previous Button Action

  let handleNext = () => {
    if (activeTab === 0 && selectedTab === 0) {
      setSelectedTab(1);
      // setActiveTab(1);
    } else if (activeTab === 0 && selectedTab === 1) {
      setSelectedTab(2);
    } else if (activeTab === 0 && selectedTab === 2) {
      setActiveTab(1);
    } else if (activeTab === 1 && !loginMethod) {
      setLoginError(true);
      setMessage("Login In Method Required!");
      setTimeout(() => {
        setLoginError(false);
      }, 2000);
    } else if (activeTab === 1 && loginMethod) {
      setActiveTab(2);
    } else if (activeTab === 2 && !loginMethod) {
      setActiveTab(1);
      setLoginError(true);
      setMessage("Login In Method Required!");
      setTimeout(() => {
        setLoginError(false);
      }, 2000);
    } else {
      let images = [];
      if (
        landingLoginD.url ||
        landingLoginM.url ||
        endscreenD.url ||
        endscreenM.url ||
        favicon.url
      ) {
        images.push(landingLoginD);
        images.push(endscreenD);
        images.push(landingLoginM);
        images.push(endscreenM);
        images.push(favicon);
      }


      const newPersonalInFeilds = [];
      const newAcademicFeilds = [];

      personalInformation.forEach((element) => {
        const index = personalInFeilds.indexOf(element);
        if (index !== -1) {
          newPersonalInFeilds.push(personalInFeilds[index]);
        }
      });

      academicRecords.forEach((element) => {
        const index = academicFeilds.indexOf(element);
        if (index !== -1) {
          newAcademicFeilds.push(academicFeilds[index]);
        }
      });



      // console.log(newPersonalInFeilds, " ==> personalInFeilds");
      // console.log(newAcademicFeilds, " ==> academicFeilds");
      // console.log(newEmploymentFeilds, " ==> employmentFeilds");

      let data = {
        personalInFeilds: newPersonalInFeilds,
        personalInformationData,
        academicFeilds: newAcademicFeilds,
        academicInformationData,
        loginMethod,
        landingLoginD,
        landingLoginM,
        endscreenD,
        endscreenM,
        favicon,
        images: images.filter((e) => e !== ""),
      };

      let step = 4;
      // redux function
      props.customizeStep(data, step);
    }
  };

  let handlePrevious = () => {
    if (activeTab === 2) {
      setActiveTab(1);
    } else if (activeTab === 1) {
      setActiveTab(0);
    } else {
      props.previousStep(2);
    }
  };
  // modal for desktop
  const [imageModalRegDesk, setimageModalRegDesk] = useState(false);

  const showImageModalRegDesk = () => {
    setimageModalRegDesk(true);
  };

  const hideImageModalRegDesk = () => {
    setimageModalRegDesk(false);
  };

  // desktop modal end

  // modal for mobile
  const [imageModalRegMbl, setimageModalRegMbl] = useState(false);
  const showImageModalRegMbl = () => {
    setimageModalRegMbl(true);
  };

  const hideImageModalRegMbl = () => {
    setimageModalRegMbl(false);
  };
  // mobile modal end

  // modal end screen Desktop
  const [imageModalEndScrDesk, setimageModalEndScrDesk] = useState(false);
  const showImageModalEndScrDesk = () => {
    setimageModalEndScrDesk(true);
  };

  const hideImageModalEndScrDesk = () => {
    setimageModalEndScrDesk(false);
  };
  // end screen desktop modal end

  // modal end screen mobile
  const [imageModalEndScrMbl, setimageModalEndScrMbl] = useState(false);
  const showImageModalEndScrMbl = () => {
    setimageModalEndScrMbl(true);
  };

  const hideImageModalEndScrMbl = () => {
    setimageModalEndScrMbl(false);
  };

  // modal end screen Favicon
  const [imageModalFavicon, setimageModalFavicon] = useState(false);
  const showImageModalFavicon = () => {
    setimageModalFavicon(true);
  };

  const hideImageModalFavicon = () => {
    setimageModalFavicon(false);
  };

  //   Tab Handler
  let handleTab = (event, value) => {
    setActiveTab(value);
    setSelectedTab(0);
  };

  // update Plan

  let updatePlan = () => {
    setUpgrade(!upgrade);
  };

  let onCloseUpgrade = () => {
    setUpgrade(!upgrade);
  };

  // useEffect(() => {
  //   let paidCheck = tabsData[activeTab].paid;
  //   if (paidCheck || fields[selectedTab].paid) {
  //     setTimeout(() => {
  //       setUpgrade(!upgrade);
  //     }, 400);
  //   }
  // }, [activeTab, selectedTab]);

  return (
    <>
      {upgrade ? (
        <UpgradeCard type="STANDARD" onCloseUpgrade={onCloseUpgrade} />
      ) : (
        <div className="2xl:w-7/12 xl:w-7/12 lg:w-7/12 w-11/12">
          <div className="bg-white rounded-md shadow-lg  2xl:px-10 xl:px-10 lg:px-10 px-4 py-8">
            <Tabs onChange={handleTab} current={activeTab} data={tabsData}>
              {activeTab === 0 ? (
                <div>
                  <div className="flex flex-row">
                    {fields.map((item, i) => {
                      return (
                        <div key={i}>
                          <button
                            onClick={() => {
                              setSelectedTab(item.no);
                            }}
                            className={`${selectedTab === i
                                ? "bg-[#FFD700]"
                                : "bg-[#E1E1E1]"
                              } text-sm  px-4 py-4 rounded-b-lg	mr-3`}
                          >
                            <div className="flex flex-row items-center flex-wrap">
                              <span
                                className={`${selectedTab === i
                                    ? "text-[#3B4345] "
                                    : "text-[#AAA4A4]"
                                  } font-bold`}
                              >
                                {item.name}
                              </span>
                              {item.paid ? (
                                <img
                                  src={toAbsoluteUrl(
                                    `/media/login/daimond.png`
                                  )}
                                  alt="upgrade icon"
                                  className={`h-5  w-5  object-contain ml-2`}
                                />
                              ) : null}
                            </div>
                          </button>
                        </div>
                      );
                    })}
                  </div>

                  {/* Registration Fields Start */}

                  {selectedTab === 0 ? (
                    <div className="my-4 w-12/12">
                      <h3 className="text-[#007E8C] font-bold text-2xl my-2">
                        Personal Information
                      </h3>
                      <p className="text-[#4B4141] text-lg my-2 font-semibold mb-6 ">
                        Select your preferred fields for candidates to provide
                      </p>
                      <div className="w-max">
                        <CheckBox
                          id={`all`}
                          label="Mark all fields"
                          selected={selectPersonalInAll}
                          onChange={handleSelectAll}
                        />
                      </div>

                      <div className="flex flex-row flex-wrap mt-4">
                        {personalInformationData.map((item, i) => {
                          return (
                            <div
                              className="2xl:w-2/6 xl:w-2/6 lg:w-2/6 w-1/2"
                              key={i}
                            >
                              <CheckBox
                                id={`personalInformation-${i}`}
                                label={item}
                                key={i}
                                selected={personalInFeilds.includes(item)}
                                disabled={disPersonalInFeilds.includes(item)}
                                value={item}
                                onChange={handlePersonalInformationChange}
                              />
                            </div>
                          );
                        })}
                      </div>
                      <div
                        onClick={updatePlan}
                        className="flex flex-row cursor-pointer items-center mt-4"
                      >
                        <p className="text-[#4B4141] font-semibold text-lg">
                          {" "}
                          Upgrade your plan to use the fields below
                        </p>
                        <img
                          src={toAbsoluteUrl(`/media/login/daimond.png`)}
                          alt="Upgrade Package Image"
                          className="w-4 ml-3 h-auto my-6"
                        />
                      </div>
                      <div className="my-1 flex flex-row flex-wrap mt-3">
                        {personalPaid &&
                          personalPaid.map((item, i) => {
                            return (
                              <div
                                className="2xl:w-2/6 xl:w-2/6 lg:w-2/6 w-1/2"
                                key={i}
                              >
                                <div className="flex flex-row mb-6">
                                  <LockClosedIcon className="w-6 h-6 py-1 bg-[#B1B1B1] rounded-sm text-white" />

                                  <p className="text-[#878787] text-[1rem] font-normal ml-3">
                                    {item}
                                  </p>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  ) : selectedTab === 1 ? (
                    <div className="my-4">
                      <h3 className="text-[#007E8C] text-3xl font-bold my-6">
                        Academic Record (Qualification)
                      </h3>
                      <p className="text-[#4B4141] text-lg my-2 font-semibold mb-6 ">
                        Select your preferred fields for candidates to provide
                      </p>
                      <div className="w-max">
                        <CheckBox
                          id={`allPersonal`}
                          label="Mark all fields"
                          selected={selectAcademicAll}
                          onChange={handleAcademicAll}
                        />
                      </div>

                      <div className="flex flex-row flex-wrap mt-4">
                        {academicRecords.map((item, i) => {
                          return (
                            <div
                              className="2xl:w-2/6 xl:w-2/6 lg:w-2/6 w-1/2"
                              key={i}
                            >
                              <CheckBox
                                id={`academic-${i}`}
                                label={item}
                                selected={academicFeilds.includes(item)}
                                key={i}
                                value={item}
                                onChange={handleAcademicChange}
                                disabled={disAcademicFeilds.includes(item)}
                              />
                            </div>
                          );
                        })}
                      </div>

                      <div
                        onClick={updatePlan}
                        className="flex flex-row cursor-pointer items-center mt-4"
                      >
                        <p className="text-[#4B4141] font-semibold text-lg">
                          {" "}
                          Upgrade your plan to use the fields below
                        </p>
                        <img
                          src={toAbsoluteUrl(`/media/login/daimond.png`)}
                          alt="Upgrade Package Image"
                          className="w-4 ml-3 h-auto my-6"
                        />
                      </div>
                      <div className="my-1 flex flex-row flex-wrap mt-6">
                        {academicRecordsPaid.map((item, i) => {
                          return (
                            <div
                              className="2xl:w-2/6 xl:w-2/6 lg:w-2/6 w-1/2"
                              key={i}
                            >
                              <div className="flex flex-row mb-6">
                                <LockClosedIcon className="w-6 h-6 py-1 bg-[#B1B1B1] rounded-sm text-white" />
                                <p className="text-[#878787] text-[1rem] font-normal ml-3">
                                  {item}
                                </p>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ) : selectedTab === 2 ? (
                    <div className="my-4">
                      <h3 className="text-[#007E8C] text-3xl font-bold my-6">
                        Employment History
                      </h3>

                      <p className="text-[#4B4141] text-lg my-2 font-semibold mb-6 ">
                        Select employment fields from options below
                      </p>

                      <div className="my-1 flex flex-row flex-wrap mt-6">
                        {employmentHistoy.map((item, i) => {
                          return (
                            <div
                              className="2xl:w-2/6 xl:w-2/6 lg:w-2/6 w-1/2"
                              key={i}
                            >
                              <div className="flex flex-row mb-6">
                                <LockClosedIcon className="w-6 h-6 py-1 bg-[#B1B1B1] rounded-sm text-white" />

                                <p className="text-[#878787] text-[1rem] font-normal ml-3">
                                  {item}
                                </p>
                              </div>
                            </div>
                          );
                        })}
                      </div>

                      <UploadFile
                        accept=".csv, text/csv"
                        disabled={true}
                        imgSize=".csv, text/csv"
                        title="Please insert your file for ‘Area Of Interest’"
                      />

                      {/* <p className="text-[#878787] font-normal text-sm">
                        Download Sample File
                      </p> */}
                    </div>
                  ) : null}
                </div>
              ) : activeTab === 1 ? (
                <div>
                  <div className="flex  flex-wrap justify-between 2xl:items-start xl:items-start lg:items-start  2xl:flex-row xl:flex-row lg:flex-row flex-col items-center">
                    <div className="2xl:w-6/12 xl:w-6/12 lg:w-6/12 w-full">
                      <p className="text-[#4B4141] font-bold text-lg mb-6">
                        Select your preferred log in method
                      </p>

                      <button onClick={updatePlan}>
                        <div className="flex flex-row flex-wrap">
                          <Radio
                            label="LinkedIn Profile"
                            id={`radioInput`}
                            value={loginMethod}
                            checked={
                              loginMethod === "linkedLogin" ? true : false
                            }
                            onChange={() => setLoginMethod("linkedLogin")}
                            disabled={true}
                          />
                          <img
                            src={toAbsoluteUrl(`/media/login/daimond.png`)}
                            alt="upgrade icon"
                            className={`w-5 object-contain ml-[-10px]`}
                          />
                        </div>
                      </button>
                      <Radio
                        id="radioInput"
                        label="Personal Email Address"
                        value={loginMethod}
                        checked={loginMethod === "emailLogin" ? true : false}
                        onChange={() => setLoginMethod("emailLogin")}
                      />
                    </div>
                    <div className="2xl:w-[50%] xl:w-[50%] lg:w-[50%] w-full">
                      <InformationCircleIcon
                        data-tip={`Choose whether you want candidates to use their LinkedIn accounts to log in or their email addresses`}
                        data-for="inCandidateVideo"
                        className="text-[#007E8C] h-6 w-6 rounded-full 2xl:ml-[-24%]  xl:ml-[-24%] mt-1"
                      />
                      <ReactTooltip
                        id="inCandidateVideo"
                        place="right"
                        effect="solid"
                        backgroundColor="#007E8C"
                        className="tooltipcustom"
                      ></ReactTooltip>
                    </div>
                  </div>

                  {loginError ? (
                    <div className="w-max mx-auto">
                      <ErrorMessage
                        onClick={() => setLoginError(false)}
                        text={message}
                      />
                    </div>
                  ) : null}
                </div>
              ) : activeTab === 2 ? (
                <div>
                  <div className="flex flex-row 2xl:flex-nowrap xl:flex-nowrap lg:flex-nowrap flex-wrap justify-between">
                    <div className="2xl:w-6/12 xl:w-6/12 lg:w-6/12 w-full">
                      <UploadFile
                        disabled={true}
                        // value={landingLoginD.name}
                        title="Upload Registration Screen "
                        imgSize="1920*1080"
                        children={<BiDesktop className="ml-2 w-4 h-4 " />}
                        onChange={(e) => {
                          let file = e.target.files[0];
                          if (/\.(jpe?g|png)$/i.test(file.name)) {
                            const reader = new FileReader();
                            reader.addEventListener("load", () => {
                              setLandingLoginD({
                                url: "landingLoginD",
                                name: file.name,
                                file: reader.result,
                              });
                            });
                            reader.readAsDataURL(file);
                          } else {
                            setImageUploadError(true);
                            setMessage("You can't upload this type of file.");
                            setTimeout(() => {
                              setImageUploadError(false);
                            }, 2000);
                          }
                        }}
                      />

                      {imageModalRegDesk && (
                        <Lightbox
                          medium={toAbsoluteUrl(
                            `/media/customizeStep/registration_D.png`
                          )}
                          large={toAbsoluteUrl(
                            `/media/customizeStep/registration_D.png`
                          )}
                          alt="Desktop Main Screen"
                          onClose={hideImageModalRegDesk}
                        />
                      )}
                      <div className="my-6">
                        <UploadFile
                          disabled={true}
                          // value={endscreenD.name}
                          imgSize="1920*1080"
                          title="Upload End Screen"
                          children={<BiDesktop className="ml-2 w-4 h-4" />}
                          onChange={(e) => {
                            let file = e.target.files[0];
                            if (/\.(jpe?g|png)$/i.test(file.name)) {
                              const reader = new FileReader();
                              reader.addEventListener("load", () => {
                                setEndScreenD({
                                  url: "endscreenD",
                                  name: file.name,
                                  file: reader.result,
                                });
                              });
                              reader.readAsDataURL(file);
                            } else {
                              setImageUploadError(true);
                              setMessage("You can't upload this type of file.");
                              setTimeout(() => {
                                setImageUploadError(false);
                              }, 2000);
                            }
                          }}
                        />

                        {imageModalEndScrDesk && (
                          <Lightbox
                            medium={toAbsoluteUrl(
                              `/media/customizeStep/Endscreen_D.png`
                            )}
                            large={toAbsoluteUrl(
                              `/media/customizeStep/Endscreen_D.png`
                            )}
                            alt="Desktop End Screen"
                            onClose={hideImageModalEndScrDesk}
                          />
                        )}
                      </div>

                      {/* for fav icon */}

                      <div className="my-6">
                        <UploadFile
                          disabled={true}
                          // value={favicon.name}
                          title="Upload Favicon Icon"
                          imgSize="16*16"
                          onChange={(e) => {
                            let file = e.target.files[0];
                            if (
                              /\.(gif|jpe?g|tiff?|png|ico)$/i.test(file.name)
                            ) {
                              const reader = new FileReader();
                              reader.addEventListener("load", () => {
                                setFavicon({
                                  url: "tabIcon",
                                  name: file.name,
                                  file: reader.result,
                                });
                              });
                              reader.readAsDataURL(file);
                            } else {
                              setImageUploadError(true);
                              setMessage("You can't upload this type of file.");
                              setTimeout(() => {
                                setImageUploadError(false);
                              }, 2000);
                            }
                          }}
                        />

                        {imageModalFavicon && (
                          <Lightbox
                            medium={toAbsoluteUrl(
                              `/media/customizeStep/Endscreen_M.png`
                            )}
                            large={toAbsoluteUrl(
                              `/media/customizeStep/Endscreen_M.png`
                            )}
                            alt="Favicon Icon Example"
                            onClose={hideImageModalFavicon}
                          />
                        )}
                      </div>
                      {/* fav icon end*/}
                    </div>
                    <div className="2xl:w-6/12 xl:w-6/12 lg:w-6/12 w-full 2xl:ml-4 xl:ml-4 lg:ml-4 ml-0">
                      <UploadFile
                        disabled={true}
                        // value={landingLoginM.name}
                        title="Upload Registration Screen"
                        imgSize="1080*1920"
                        children={<BiMobile className="ml-2 w-4 h-4" />}
                        onChange={(e) => {
                          let file = e.target.files[0];
                          if (/\.(jpe?g|png)$/i.test(file.name)) {
                            const reader = new FileReader();
                            reader.addEventListener("load", () => {
                              setLandingLoginM({
                                url: "instructionsM",
                                name: file.name,
                                file: reader.result,
                              });
                            });
                            reader.readAsDataURL(file);
                          } else {
                            setImageUploadError(true);
                            setMessage("You can't upload this type of file.");
                            setTimeout(() => {
                              setImageUploadError(false);
                            }, 2000);
                          }
                        }}
                      />

                      {imageModalRegMbl && (
                        <Lightbox
                          medium={toAbsoluteUrl(
                            `/media/customizeStep/registration_M.png`
                          )}
                          large={toAbsoluteUrl(
                            `/media/customizeStep/registration_M.png`
                          )}
                          alt="Mobile Main Screen"
                          onClose={hideImageModalRegMbl}
                        />
                      )}
                      <div className="my-6">
                        <UploadFile
                          disabled={true}
                          // value={endscreenM.name}
                          title="Upload End Screen"
                          imgSize="1080*1920"
                          children={<BiMobile className="ml-2 w-4 h-4 " />}
                          onChange={(e) => {
                            let file = e.target.files[0];
                            if (/\.(jpe?g|png)$/i.test(file.name)) {
                              const reader = new FileReader();
                              reader.addEventListener("load", () => {
                                setEndScreenM({
                                  url: "endscreenM",
                                  name: file.name,
                                  file: reader.result,
                                });
                              });
                              reader.readAsDataURL(file);
                            } else {
                              setImageUploadError(true);
                              setMessage("You can't upload this type of file.");
                              setTimeout(() => {
                                setImageUploadError(false);
                              }, 2000);
                            }
                          }}
                        />

                        {imageModalEndScrMbl && (
                          <Lightbox
                            medium={toAbsoluteUrl(
                              `/media/customizeStep/Endscreen_M.png`
                            )}
                            large={toAbsoluteUrl(
                              `/media/customizeStep/Endscreen_M.png`
                            )}
                            alt="Mobile End Screen"
                            onClose={hideImageModalEndScrMbl}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  {artWorkError ? (
                    <div className="w-max mx-auto">
                      <ErrorMessage text={message} />
                    </div>
                  ) : null}

                  {imageUploadError ? (
                    <div className="w-max mx-auto">
                      <ErrorMessage
                        onClick={() => setImageUploadError(false)}
                        text={message}
                      />
                    </div>
                  ) : null}

                  <div className="flex flex-row">
                    <InformationCircleIcon className="text-gray-400 2xl:block xl:block lg:block hidden h-6 w-6 rounded-full " />
                    <p className="text-[#A7A7A7]  text-sm font-normal px-3 2xl:w-7/12 xl:w-7/12 lg:w-7/2">
                      Adding custom artwork is optional. Your assessment game
                      will have our standard art screens if you don't upload any
                      files here.
                    </p>
                  </div>
                </div>
              ) : null}
            </Tabs>
          </div>
          {/* Handle Next Button */}
          <div className="my-6 flex justify-between">
            <IconButton
              onClick={handlePrevious}
              name="Previous"
              customStyle="2xl:h-22 xl:h-22 h-12 2xl:px-10 xl:px-10 px-6 flex-row-reverse bg-[#007E8C] 2xl:text-lg xl:text-lg text-sm  font-semibold  2xl:tracking-[0.1rem] xl:tracking-[0.1rem] "
            >
              <FaAngleLeft className="text-white mr-1 mt-[1px]" />
            </IconButton>
            <div className="text-center">
              <h1 className="font-medium text-xl  text-[#3B4345]">
                Your Current Plan:{" "}
                <b className="font-bold text-xl text-[#007E8C]">STANDARD</b>
              </h1>
              <button
                onClick={() => updatePlan()}
                className="font-medium underline text-[#007E8C] mt-2"
              >
                Upgrade Your Plan
              </button>
            </div>

            <IconButton
              onClick={handleNext}
              name="Next"
              customStyle="2xl:h-22 xl:h-22 h-12 2xl:px-10 xl:px-10 px-6 bg-[#007E8C] 2xl:text-lg xl:text-lg text-sm font-semibold  tracking-[0.1rem]"
            >
              <FaAngleRight className="text-white  mt-[1px]" />
            </IconButton>
          </div>
        </div>
      )}

      <HelpButton screen="login" />
    </>
  );
};
const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, { customizeStep, previousStep })(
  CustomizeStep
);
